import React from "react";
import ATMSelect from "../../atoms/formFields/ATMSelect/ATMSelect";
import ATMTextField from "../../atoms/formFields/ATMTextField/ATMTextField";
import ATMLoadingButton from "../../atoms/ATMLoadingButton/ATMLoadingButton";
import { FormikProps } from "formik";


type Props = {
  formikProps: FormikProps<any>;
  dropdownOptions: any;
};
const GloballySearch = ({ formikProps, dropdownOptions }: Props) => {
  const { values, setFieldValue } = formikProps;
  return (
    <>
      <div className="flex  items-center gap-4 ">
        <div className="w-[80px] sm:w-[80px] md:w-[100px] xl:w-[100px] 2xl:w-[120px] pb-1">
          <ATMSelect
            value={values?.service}
            onChange={(e) => {
              setFieldValue("service", e.target.value);
              setFieldValue("srnNumber", '');
            }}
            options={dropdownOptions.services}
            name="service"
            size="small"
          />
        </div>

      { values?.service=="pan"  && <div className="w-[80px] sm:w-[80px] md:w-[100px] xl:w-[100px] 2xl:w-[120px] pb-1">
          <ATMSelect
            value={values?.searchType}
            onChange={(e) => {
              setFieldValue("searchType", e.target.value);
                setFieldValue("srnNumber", '');

            }}
            options={dropdownOptions.searchOption}
            name="searchType"
            size="small"
          />
        </div>}

        <div className="2xl:w-[240px]  xl:w-[130px]  sm:w-[100px]  xs:w-[100px]">
          <ATMTextField
            name="srnNumber"
            value={values?.srnNumber}
            onChange={(e) => setFieldValue("srnNumber", e.target.value.trim())}
            placeholder={`Search By ${values?.searchType}`}
            size={30}
          />
        </div>
        <div className="2xl:w-[100px]  xl:w-[80px]  sm:w-[50px]  xs:w-[50px]">
          <ATMLoadingButton
            type="submit"
            className="bg-primary-main text-white text-[10px] 2xl:p-2 sm:p-2  xs:p-1"
          >
            Search
          </ATMLoadingButton>
        </div>
      </div>{" "}
    </>
  );
};

export default GloballySearch;
